import * as React from 'react';
import './Loading.scss';

interface IProps {
    message: string;
}

export const LoadingInlinePanel = (props : IProps) => {

    return <div id="inline-sloading-panel">
            <h1>
                { props.message }
                <span>.</span><span>.</span><span>.</span>
            </h1>
        </div>;

};
